import { Result } from "antd";
// import { BASE_PATH } from "../../api/api";

export default function RParticipante({ response }) {
  if (!response.found) {
    return <Result status="error" title="Lo sentimos" subTitle="No encontramos al postulante" />;
  } else {
    const { data } = response;

    return (
      <div className="text-center">
        <h1
          className={
            "text-lg text-center p-1 text-white font-semibold " +
            (response.duplicado ? "bg-red-400" : "bg-green-500")
          }
        >
          {data?.nombre + " " + data?.apellido}
        </h1>
        {response.duplicado && <p className="text-sm my-2 text-red-600">YA SE MARCÓ ASISTENCIA</p>}
        <div className="text-sm my-2">
          DNI: <span className="font-bold">{data?.nrodocumento || ""}</span>
        </div>
        {/* <img
          className="mx-auto border-8"
          src={BASE_PATH + "/v1/aux/view?filepath=fotos/" + data?.fotografia}
          width={150}
          height={180}
          alt={"fotografia de postulante " + data?.nrodocumento}
        /> */}

        <div className="flex flex-col items-center">
          <p className="font-semibold text-gray-500 mt-3">CANAL</p>
          <h2 className="text-xl font-bold">{data?.canal || ""}</h2>

          <p className="font-semibold text-gray-500 mt-3">CARRERA</p>
          <h2 className="text-xl font-bold">{data?.carrera || ""}</h2>

          <p className="font-semibold text-gray-500 mt-3">MODALIDAD DE INGRESO</p>
          <h2 className="text-xl font-bold">{data?.modalidadingreso || ""}</h2>

          <p className="font-semibold text-gray-500 mt-3">LLENÓ FORMULARIO</p>
          <h2
            className={
              "text-xl font-bold " +
              (response.encuesta === true ? "text-green-500" : "text-red-500")
            }
          >
            {response.encuesta ? "SÍ" : "NO"}
          </h2>
        </div>
      </div>
    );
  }
}
